module.exports = __webpack_public_path__ + "static/media/arrow_back_gold.5c5057b0.svg";